export default __webpack_public_path__ + "static/media/Seguimiento_1.45be55d4.svg";